@if (meeting) {
    <adapt-meeting-integration-prompt [disabled]="disabled"
                                      [showLocal]="showInvitationPrompt"
                                      [linkDisabled]="true"
                                      [contentTemplate]="checkingProviderStatus ? checkingProviderStatusDisplay : integrationOptions"></adapt-meeting-integration-prompt>
    <ng-template #checkingProviderStatusDisplay>
        <div class="not-organiser-warning w-100">
            <adapt-loading-spinner></adapt-loading-spinner>
        </div>
    </ng-template>
    <ng-template #integrationOptions>
        @if (!isOrganiser) {
            <div class="alert alert-warning not-organiser-warning small p-2">
                Only <b>{{ organiserName }}</b> can update the calendar entry.
                <br />
                Please ask them to sync the meeting once you have finished editing the meeting.
            </div>
        } @else {
            @if (showInvitationPrompt || showTeamsPrompt) {
                <div class="d-flex flex-column gap-2 align-self-end">
                    @if (showInvitationPrompt) {
                        <div>
                            <dx-check-box text="Automatically send calendar invitations"
                                          [value]="sendInvitations"
                                          [disabled]="meeting.extensions.isEnded"
                                          (valueChange)="onSendInvitationsChange($any($event))"></dx-check-box>
                            @if (!sendInvitations && !meeting.extensions.isEnded) {
                                <div class="mt-1 small">Invitations can still be sent manually later on.</div>
                            }
                            @if (meeting.extensions.isEnded) {
                                <div class="mt-1 small">Invitations can't be sent for an already ended meeting.</div>
                            }
                        </div>
                    }
                    @if (showTeamsPrompt) {
                        <div>
                            <dx-check-box text="Create Microsoft Teams meeting"
                                          [disabled]="!sendInvitations"
                                          [value]="createTeamsMeeting"
                                          (valueChange)="onCreateTeamsMeetingChange($any($event))"></dx-check-box>
                        </div>
                        <div>
                            @if (!existingProviderMeeting) {
                                <button adaptButton="downloadLink"
                                        (click)="attachExistingRemoteMeeting()">Attach existing Outlook event</button>
                            } @else {
                                <button adaptButton="downloadLink"
                                        (click)="detachExistingRemoteMeeting()">Detach existing Outlook event</button>
                            }
                        </div>
                    }
                </div>
            }
        }
    </ng-template>
    @if (showTitle) {
        <h3>Title</h3>
        <p>{{ meeting.name }}</p>
    }
    <h3 [class.mt-3]="showTitle">Attendees</h3>
    <adapt-select-people [people]="attendeePeople"
                         (peopleChange)="onMeetingAttendeesChange($event)"
                         [teamGroup]="meeting.team"
                         [showClearButton]="true"
                         [filter]="meetingAttendeeFilterFunction"
                         [disabled]="disabled"
                         data-test="add-attendee"></adapt-select-people>
    @if (attendeePeople.length > 0 && loadingAvailability) {
        <adapt-schedule-meeting-display-availability [loading]="true"></adapt-schedule-meeting-display-availability>
    }
    @if (!loadingAvailability) {
        @if (peopleAvailable.length > 0) {
            <adapt-schedule-meeting-display-availability [names]="peopleAvailable"
                                                         [available]="true"></adapt-schedule-meeting-display-availability>
        }
        @if (peopleUnavailable.length > 0) {
            <adapt-schedule-meeting-display-availability [names]="peopleUnavailable"
                                                         [available]="false"></adapt-schedule-meeting-display-availability>
        }
        @if (peopleNoEmail.length > 0 && sendInvitations) {
            <adapt-schedule-meeting-display-availability [names]="peopleNoEmail"
                                                         [available]="false"
                                                         message="{{ peopleNoEmail.length > 1 ? 'have' : 'has' }} their login email set to private and therefore will not receive an invite. ">
                <a [href]="PrivateEmailLearnMoreUrl"
                   target="_blank">Click here</a>
                to find out more.
            </adapt-schedule-meeting-display-availability>
        }
    }
    <div class="mt-3 row">
        <div class="col-6">
            <h3>Start Time</h3>
            <dx-date-box class="meeting-time-select"
                         type="datetime"
                         applyValueMode="instantly"
                         [useMaskBehavior]="true"
                         [value]="meeting.meetingDateTime"
                         (valueChange)="onMeetingStartTimeChange($any($event))"
                         [displayFormat]="meeting.extensions.dateFormat"
                         [disabled]="disabled"
                         [isValid]="!startTimeValidationError"
                         [validationError]="startTimeValidationError"
                         data-test="meeting-date">
                <dxo-date-box-calendar-options [showTodayButton]="true"></dxo-date-box-calendar-options>
            </dx-date-box>
        </div>
        <div class="col-6">
            <h3>Duration</h3>
            <dx-select-box class="meeting-duration-select"
                           [items]="meetingDurations"
                           [value]="meeting.extensions.selectedDuration"
                           (valueChange)="onMeetingDurationChange($event)"
                           [searchEnabled]="false"
                           displayExpr="text"
                           placeholder="Select duration..."
                           [showClearButton]="false"
                           [disabled]="disabled"
                           [isValid]="!endTimeValidationError"
                           [validationError]="endTimeValidationError"
                           data-test="meeting-duration">
                <div *dxTemplate="let item of 'item'">
                    <div class="d-flex flex-row justify-content-between">
                        <span>{{ item.text }}</span>
                        <span class="text-muted small">{{ item.time | adaptTime }}</span>
                    </div>
                </div>
            </dx-select-box>
            <small class="text-muted">End time: {{ meeting.endTime | adaptTime }}</small>
        </div>
    </div>
    <div class="mt-2">
        <h3>Location</h3>
        <adapt-select-meeting-location [location]="meetingLocation"
                                       (locationChange)="onMeetingLocationChange($event)"
                                       [required]="false"
                                       [disabled]="disabled"></adapt-select-meeting-location>
        @if (meetingLocation && meetingLocation.emailAddress) {
            <adapt-schedule-meeting-display-availability [loading]="loadingAvailability"
                                                         [names]="[meetingLocation.name ?? meetingLocation.emailAddress]"
                                                         [available]="locationAvailable"></adapt-schedule-meeting-display-availability>
        }
    </div>
}
